// Карточка биомаркера в каталоге, органе и на экране ревью.
// После D-3 (§2.3) это тонкая обёртка над MarkerRow: разметка, кегли и
// отступы живут там, здесь остаётся только контракт пропсов, на который
// завязаны четыре экрана.

import { MarkerRow } from '@/components/dashboard/MarkerRow';
import type { ClinicalStatus, DashboardDelta, OptimumStatus } from '@/api/types';
import { ItemErrorBoundary } from '@/components/ErrorBoundary';

type Props = {
  name: string;
  normalRangeLabel: string;
  value: number;
  unit: string;
  /**
   * HEAL-33: качественный ответ («не обнаружено», «обнаружено»). Если задан —
   * показываем его вместо числа: `value` у таких показателей это порядковая
   * оценка (0/1), нужная только для сравнения с нормой.
   */
  valueText?: string | null;
  clinicalStatus: ClinicalStatus;
  optimumStatus?: OptimumStatus;
  delta?: DashboardDelta | null;
  hasHistory?: boolean;
  onClick?: () => void;
};

export function BiomarkerCard({
  name,
  normalRangeLabel,
  value,
  unit,
  valueText = null,
  clinicalStatus,
  optimumStatus = null,
  delta,
  hasHistory = false,
  onClick,
}: Props) {
  return (
    <MarkerRow
      variant="catalog"
      name={name}
      normalRangeLabel={normalRangeLabel}
      value={value}
      unit={unit}
      valueText={valueText}
      clinicalStatus={clinicalStatus}
      optimumStatus={optimumStatus}
      delta={delta}
      hasHistory={hasHistory}
      onClick={onClick}
    />
  );
}

/**
 * HEAL-47: карточка под точечной границей ошибок.
 *
 * Требование тикета: «если один анализ или показатель вызывает ошибку, приложение
 * должно пропустить проблемный объект, открыть интерфейс и показать уведомление».
 * До этого один неожиданный `null` в одном показателе уносил весь список — а вместе
 * с ним и весь экран, потому что границ в приложении не было вовсе.
 *
 * В списках используем ВСЕГДА эту версию, а не BiomarkerCard напрямую.
 */
export function SafeBiomarkerCard(props: Props) {
  return (
    <ItemErrorBoundary scope="biomarker-card">
      <BiomarkerCard {...props} />
    </ItemErrorBoundary>
  );
}
